<mat-form-field class="example-full-width" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" />
  <button matSuffix mat-icon-button color="primary" type="button"
    *ngIf="showCreateButton" aria-label="Создать договор"
    [title]="canCreate ? 'Создать договор' : 'Сначала выберите поставщика и организацию'"
    [disabled]="!canCreate || createDisabled || control.disabled || creating"
    (click)="$event.stopPropagation(); openCreateDialog()">
    <mat-icon>add</mat-icon>
  </button>
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayProperty"
    (optionSelected)="onSelect($event)"
  >
    <mat-option *ngIf="!canSearch" disabled> Выберите {{ missingFilterLabel }} </mat-option>
    <mat-option *ngFor="let contract of filteredOptions | async" [value]="contract">
      {{ formatOption(contract) }}
    </mat-option>
    <mat-option #createOption *ngIf="canCreate && !createDisabled && !control.disabled && !creating" [value]="control.value">
      + Создать новый договор
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
